import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexRow } from 'styles/layouts';

export const Wrapper = styled(FlexRow)<{ fullHeight: boolean }>`
  width: 100%;
  gap: 25px;
  flex-direction: column;

  ${QUERIES.tabletAndUp} {
    flex-direction: row;
    height: ${({ fullHeight }) => (fullHeight ? '540px' : 'unset')};
    max-height: 556px;
  }

  ${QUERIES.largeTabletAndUp} {
    height: ${({ fullHeight }) => (fullHeight ? '713px' : '540px')};
  }

  ${QUERIES.laptopAndUp} {
    height: ${({ fullHeight }) => (fullHeight ? '800px' : '560px')};
  }
`;

export const SourceTemplateWrapper = styled.div`
  flex: 1;
  aspect-ratio: 1/1;

  ${QUERIES.tabletAndUp} {
    aspect-ratio: auto;
  }
`;

export const ExpandedContentSlider = styled.div`
  background: ${themeStyle.varInkSuperLight};
  border-radius: ${themeStyle.radiusMedium};
  padding: 12px;
  box-sizing: border-box;
`;
